module.exports = __webpack_public_path__ + "img/image.4f9348d5.png";